<template>
  <div>
    <Card :dis-hover="true">
      <Table
          :loading="dataLoading"
          :columns="columns"
          :data="data"
          :border="false"
          :stripe="false"
          :highlight-current-row="true"
      >
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
export default {
  name: "sendProHistory",
  data() {
    return {
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '队伍名称',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.name)
          }
        },
        {
          title: '事件名称',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.personInCharge)
          },
        },
        {
          title: '任务描述',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.personInChargePhone)
          },
        },
        {
          title: '发起人',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.emergencyTeam.countPeople)
          },
        },
        {
          title: '行政区划',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.emergencyTeam.countPeople)
          },
        },
        {
          title: '任务下发时间',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.eventName)
          },
        },
        {
          title: '任务状态',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.updateTime)
          },
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
    }
  }
}
</script>

<style scoped>

</style>
